import { AllowedOAuthProvider, allowedOAuthProviders } from '../types/types';

export const isAllowedOAuthProvider = (provider: string): provider is AllowedOAuthProvider => {
  return Object.values(allowedOAuthProviders).includes(provider as AllowedOAuthProvider);
};
